import {
    call,
    takeLatest,
    StrictEffect,
} from 'redux-saga/effects';
import {
    ADDITIONAL_PAGE_OPTIONS,
    FLOW_DEVICE_FIRST,
    SAILS_BNT_STORAGE,
    SAILS_PARAM_FLOW_TYPE,
    SAILS_PARAM_SALESCHANNEL,
    SAILS_PARAM_SUB_ID,
    SALESCHANNEL_REDPLUS,
    REDPLUS_STORAGE,
} from '@vfde-fe/sails-constants';
import {
    getSessionStorageItemJson,
    setSessionStorageItemJson,
} from '@vfde-fe/sails_core';
import { SAILS_PARAM_HARDWAREONLY } from '../DeviceDetail/constants';
import { APP } from 'Constant';
import { SET_DEFAULT_STATE } from './constants';
import { updateStorageSaga } from '@vfde-fe/sails-storage';
import { SailsHardwareDetailsStorage } from '../DeviceDetail/interfaces/storage';
import { TariffActionCreators } from './actions';

/**
 * Tariff saga
 * Watches actions
 */
export default function* tariffSaga (): Generator<StrictEffect> {
    yield takeLatest(SET_DEFAULT_STATE, setOfferSaga);
}

/**
 * Init the session storage
 */
export function* setOfferSaga (action: ReturnType<TariffActionCreators['setDefaultState']>): Generator<StrictEffect> {
    const oldStorage = (yield call(getSessionStorageItemJson, SAILS_BNT_STORAGE)) as SailsHardwareDetailsStorage | null;
    const deviceId = window[ADDITIONAL_PAGE_OPTIONS]?.deviceId;
    const { salesChannel, subscriptionId, gigakombi: isGigakombi } = action;
    const storage: any = {
        [SAILS_PARAM_SALESCHANNEL]: salesChannel,
    };

    // Only put tariff stuff in storage when hardware only is false or not set
    if (!oldStorage?.[APP]?.[deviceId]?.[SAILS_PARAM_HARDWAREONLY]) {
        if (isGigakombi) {
            storage.gigakombi = true;
        }
        if (action.subscriptionId) {
            storage[SAILS_PARAM_SUB_ID] = {
                [salesChannel]: subscriptionId,
            };
        }
    }

    if (!oldStorage?.[SAILS_PARAM_FLOW_TYPE]) {
        storage[SAILS_PARAM_FLOW_TYPE] = FLOW_DEVICE_FIRST;
    }

    // If sales channel is redplus and there is subscription Id, we should update redplus_flow storage
    if (salesChannel === SALESCHANNEL_REDPLUS && action.subscriptionId) {
        yield call(setSessionStorageItemJson, REDPLUS_STORAGE, { activeSubscriptionId: Number(action.subscriptionId) });
    }

    yield call(updateStorageSaga, SAILS_BNT_STORAGE, storage, null, true, oldStorage);
}
